import API from '@/lib/api/sdk';

export const sdk = new API();

if (typeof window !== 'undefined') {
  (window as any).__sdk = sdk;
}
